"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPlayerState = exports.AUTO_QUALITY_LEVEL_DEFINITION = void 0;
const player_1 = require("./interfaces/player");
exports.AUTO_QUALITY_LEVEL_DEFINITION = {
    id: -1,
    name: "auto",
    bandwidth: -1,
    width: -1,
    height: -1,
};
exports.DefaultPlayerState = {
    playbackState: player_1.PlaybackState.IDLE,
    contentType: undefined,
    mediaType: undefined,
    currentTime: 0,
    duration: 0,
    seekable: { start: 0, end: 0 },
    utcCurrentTime: 0,
    utcDuration: 0,
    utcSeekable: { start: 0, end: 0 },
    currentAd: null,
    adMarkers: [],
    contentMarkers: [],
    volume: 0,
    subtitleTrack: null,
    subtitleTracks: [],
    audioTrack: null,
    audioTracks: [],
    qualityLevel: exports.AUTO_QUALITY_LEVEL_DEFINITION,
    qualityLevels: [],
    droppedFrames: 0,
    bufferingEvents: 0,
    hasStarted: false,
    isMuted: false,
    isLive: false,
    isSeekable: false,
    isAtLiveEdge: false,
};
//# sourceMappingURL=defaults.js.map